module.exports = __webpack_public_path__ + "static/media/Friend-Finder.9f13d082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Friend-Finder.png
// module id = 87
// module chunks = 0